import { ContactFormInformationResponse } from '@/core/domain/customer-support/models/ContactFormInformationResponse-response.model';
import { ContactFormRequest } from '@/core/domain/customer-support/models/ContactFormRequest.model';
import { ContactFormResponse } from '@/core/domain/customer-support/models/ContactFormResponse.model';
import { CustomerSupportRepository } from '@/core/domain/customer-support/repositories/customer-support.repository';
import { environment } from '@/env/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import _ from 'lodash';
import { catchError, forkJoin, Observable, of, switchMap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CustomerSupportImplRepository extends CustomerSupportRepository {
    constructor(private readonly httpClient: HttpClient) {
        super();
    }

    override getContactFormInformation(): Observable<ContactFormInformationResponse> {
        return forkJoin([
            this.httpClient.get(
                [
                    environment.alamoApi.BASE_HOST,
                    environment.alamoApi.ENDPOINTS.formCustomerSupportIssues,
                ].join('/'),
            ),
            this.httpClient.get(
                [
                    environment.alamoApi.BASE_HOST,
                    environment.alamoApi.ENDPOINTS.formCustomerSupportOffices,
                ].join('/'),
            ),
        ]).pipe(
            switchMap(([issuesResponse, officesResponse]) => {
                const issues = _.get(issuesResponse, 'data.issues', []);
                const offices = _.get(officesResponse, 'data.offices', []);
                const topics: { id: string; name: string }[] = [];
                const rentalOffices: { id: string; name: string }[] = [];
                _.forEach(issues, (item) =>
                    topics.push({
                        id: _.get(item, 'code'),
                        name: _.get(item, 'category'),
                    }),
                );
                _.forEach(offices, (item) =>
                    rentalOffices.push({
                        id: _.get(item, 'code'),
                        name: _.get(item, 'name'),
                    }),
                );
                return of({
                    type: 'SUCCESS',
                    action: 'CONTINUE',
                    notifications: [],
                    data: {
                        topics: topics,
                        rentalOffices: rentalOffices,
                    },
                } as ContactFormInformationResponse);
            }),
            catchError(() => {
                return of({
                    type: 'ERROR',
                    action: 'CANCEL',
                    notifications: [],
                    data: {
                        rentalOffices: [],
                        topics: [],
                    },
                } as ContactFormInformationResponse);
            }),
        );
    }

    override sendForm(
        sendFormRequest: ContactFormRequest,
    ): Observable<ContactFormResponse> {
        return this.httpClient.post<ContactFormResponse>(
            [
                environment.alamoApi.BASE_HOST,
                environment.alamoApi.ENDPOINTS.formCustomerSupport,
            ].join('/'),
            _.omit(sendFormRequest, 'recaptchaToken'),
            {},
        );
    }
}
